/*
 *
 * LanguageProvider
 *
 * This component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `translations`)
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { translations } from 'i18n';

import IntlGlobalProvider from './IntlGlobalProvider';

/**
 * LanguageProvider.js
 */
const LocaleProvider = ({ children, messages }) => {
  const { locale } = useSelector((state) => state.locale);

  return (
    <IntlProvider
      key={locale}
      locale={locale}
      messages={messages[locale]}
    >
      <IntlGlobalProvider>
        {React.Children.only(children)}
      </IntlGlobalProvider>
    </IntlProvider>
  );
};

LocaleProvider.defaultProps = {
  messages: translations,
};

LocaleProvider.propTypes = {
  /**
   * The messages containing object messages.
   */
  messages: PropTypes.object,
  /**
   * The child element of node.
   */
  children: PropTypes.element.isRequired,
};

export default LocaleProvider;
